import { AxiosResponse } from 'axios';
import { EventRegistrationForDE } from 'shell/models/event-registration';
import { HttpResponse } from 'shell/models/http-response';

export interface transformEventRegistrationResponse {
  eventCode: string;
  destinationCode: string;
  subscriberCode: string;
  progressive: string;
  microConsumer?: string;
  httpMethod?: string;
  pathConsumer?: string;
  eventDescription: string;
  subscriberDescription: string;
  destinationDescription: string;
}

export const transformEventRegistration = (
  response: AxiosResponse<HttpResponse<EventRegistrationForDE>>
): transformEventRegistrationResponse => {
  const data: EventRegistrationForDE = response.data.payload || {};
  const res: transformEventRegistrationResponse = {
    eventCode: data?.codiceTipoEvento,
    destinationCode: data?.codiceTipoDestinazione.toString() || '',
    subscriberCode: data?.codiceSottoscrittore.toString() || '',
    eventDescription: data?.descrizioneTipoEvento,
    destinationDescription: data?.descrizioneTipoDestinazione,
    subscriberDescription: data?.descrizioneSottoscrittore,
    progressive: data?.codiceSottoscrittore.toString() || '',
    httpMethod: data?.httpMethod || '',
    pathConsumer: data?.pathSpecificoConsumer || '',
    microConsumer: data?.microservizioConsumer || '',
  };
  return res;
};
